<template>
    <div class="access-denied">
        <div class="card">
            <div class="card-header bg-danger text-white">
                <h2>
                    <i class="fas fa-exclamation-triangle"></i> Access Denied
                </h2>
            </div>
            <div class="card-body">
                <p>
                    You do not have the required permissions to access this
                    page.
                </p>
                <p>
                    Please contact your administrator if you believe you should
                    have access.
                </p>
                <button @click="goBack" class="btn btn-outline-primary">
                    <i class="fas fa-arrow-left"></i> Go Back
                </button>
                <button @click="goDashboard" class="btn btn-primary ml-2">
                    <i class="fas fa-home"></i> Go to Dashboard
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AccessDenied",
    methods: {
        goBack() {
            this.$router.go(-1);
        },
        goDashboard() {
            this.$router.push({ name: "dashboard" });
        }
    }
};
</script>

<style scoped>
.access-denied {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
}
.card {
  max-width: 500px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}
</style>
